import { css, unsafeCSS } from 'lit';
import { fsFontWeightSemibold } from '@cof/fs-tokens';

export const style = css`
  @media (max-width: 600px) {
    svg {
      width: 100%;
      height: auto;
    }

    .banner {
      padding: 0;
    }

    .full-page {
      padding: 1.25rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      align-self: stretch;
    }
  }

  @media (min-width: 600px) {
    svg {
      width: 100%;
      height: 18.7rem;
    }

    .banner {
      padding: 0;
      background-color: #10253f;
      height: 15.9rem;
    }

    .full-page {
      padding: 4.341rem 1.25rem 1.25rem 1.25rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      align-self: stretch;
      max-width: 600px;
      margin: 0 auto;
    }
  }

  .header {
    padding-bottom: 1rem;
  }

  .title-text {
    fs-font-size: 1.5rem;
    font-line-height: 1.25;
    font-weight: ${unsafeCSS(fsFontWeightSemibold)};
    text-align: left;
  }

  .body {
    padding-bottom: 2rem;
  }

  .body-text {
    text-align: center;
  }

  .expiration-body {
    padding-top: 0.25rem;
    padding-bottom: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .expiration-text {
    text-align: center;
  }

  .ease-offer-card {
    width: 90%;
    height: 100%;
    background-color: #fff;
    border: 1px solid #d4d4d4;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    padding: 1rem 1.25rem 1rem 1.25rem;
    align-items: center;
  }

  .rate-container {
    align-items: stretch;
    display: flex;
    flex-direction: column;
    text-align: center;
    width: 100%;
  }

  .apr-container {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 0.25rem;
    justify-content: center;
  }

  .apr-container {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 0.25rem;
    justify-content: center;
  }

  .apr-stack {
    display: flex;
    flex-direction: column;
  }

  .apr-number {
    font-size: 5rem;
    font-weight: 600;
  }

  .apr-sign {
    font-size: 42px;
    font-weight: 600;
  }

  .apr-text {
    font-size: 1rem;
    font-weight: 400;
  }

  .continue-button {
    max-width: 100%;
  }

  .error-container {
    padding-top: 1.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    min-height: 60vh;
  }

  .phone-number-link {
    color: #141414;
    text-decoration: underline;
  }

  .error-title {
    padding-bottom: 1rem;
  }

  .error-body {
    padding-bottom: 1.5rem;
  }

  .error-access-code {
    padding-bottom: 0.5rem;
  }

  .error-try-again-later {
    padding-top: 1.5rem;
  }

  .wrapper {
    display: flex;
    padding: 1rem 1rem 1rem 1rem;
  }

  .promo-header-column {
    flex-grow: 2;
    padding-left: 1rem;
  }
`;
